export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖區最具影響力的 Web 設計規範',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage':
    '錯誤的用戶名和密碼(admin/ant.design)',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '用戶名: admin or user',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼: ant.design',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',
  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  
  // Order Statistics Page
  'pages.orders.statistics.title': '訂單統計',
  'pages.orders.statistics.dateRange': '查詢期間',
  'pages.orders.statistics.last7Days': '最近7天',
  'pages.orders.statistics.last30Days': '最近30天',
  'pages.orders.statistics.last90Days': '最近90天',
  'pages.orders.statistics.totalOrders': '總訂單數量',
  'pages.orders.statistics.totalSales': '銷售額',
  'pages.orders.statistics.refundCount': '退款商品數',
  'pages.orders.statistics.refundAmount': '退款金額',
  'pages.orders.statistics.trendChart': '營業趨勢圖',
  'pages.orders.statistics.dailyStats': '每日統計',
  'pages.orders.statistics.chart.orders': '訂單數',
  'pages.orders.statistics.chart.revenue': '銷售額',
  'pages.orders.statistics.chart.refunds': '退款數',
  'pages.orders.statistics.table.date': '日期',
  'pages.orders.statistics.table.orderCount': '訂單數',
  'pages.orders.statistics.table.revenue': '銷售額',
  'pages.orders.statistics.table.refundCount': '退款數',
  'pages.orders.statistics.table.refundAmount': '退款金額',
  'pages.orders.statistics.table.total': '共 {total} 項',

  // Live Rebate Settings
  'pages.live.rebate.title': '直播返利設定',
  'pages.live.rebate.liveTeamName': '直播團隊名稱',
  'pages.live.rebate.memberId': '會員ID',
  'pages.live.rebate.sellerId': '賣家ID',
  'pages.live.rebate.sellerPercent': '賣家%',
  'pages.live.rebate.companyPercent': '公司%',
  'pages.live.rebate.teamPercent': '團隊%',
  'pages.live.rebate.teamRebatePercent': '團隊返利%',
  'pages.live.rebate.settingTimeAdmin': '設定時間/管理員',
  'pages.live.rebate.actions': '操作',
  'pages.live.rebate.setting': '設定',
  'pages.live.rebate.detail': '詳情',
  'pages.live.rebate.delete': '刪除',
  'pages.live.rebate.addRebate': '新增返利',
  'pages.live.rebate.batchUpdate': '批次更新',
  'pages.live.rebate.selectFirst': '請先選擇項目',
  'pages.live.rebate.addSuccess': '返利新增成功',
  'pages.live.rebate.addFailed': '新增返利失敗',
  'pages.live.rebate.updateSuccess': '返利更新成功',
  'pages.live.rebate.updateFailed': '更新返利失敗',
  'pages.live.rebate.deleteSuccess': '返利刪除成功',
  'pages.live.rebate.deleteFailed': '刪除返利失敗',
  'pages.live.rebate.deleteConfirm': '刪除返利',
  'pages.live.rebate.deleteContent': '確定要刪除此返利設定嗎？',
  'pages.live.rebate.addModalTitle': '新增返利設定',
  'pages.live.rebate.editModalTitle': '編輯返利設定',
  'pages.live.rebate.liveTeamNameRequired': '請輸入直播團隊名稱',
  'pages.live.rebate.memberIdRequired': '請輸入會員ID',
  'pages.live.rebate.sellerIdRequired': '請輸入賣家ID',
  'pages.live.rebate.sellerPercentRequired': '請輸入賣家百分比',
  'pages.live.rebate.companyPercentRequired': '請輸入公司百分比',
  'pages.live.rebate.teamPercentRequired': '請輸入團隊百分比',
  'pages.live.rebate.teamRebatePercentRequired': '請輸入團隊返利百分比',
  'pages.live.rebate.loadFailed': '載入返利設定失敗',
  'pages.live.rebate.selectAtLeastTwo': '請至少選擇2個項目',
  'pages.live.rebate.batchSetting': '批次設定',
  'pages.live.rebate.batchUpdateTitle': '批次更新百分比',
  'pages.live.rebate.selectedItems': '個項目已選擇',
  'pages.live.rebate.applySetting': '套用設定',
  'pages.live.rebate.cancel': '取消',
  'pages.live.rebate.batchUpdateSuccess': '批次更新成功完成',
  'pages.live.rebate.batchUpdateFailed': '批次更新失敗',
  'pages.live.rebate.searchLabel': '搜尋',
  'pages.live.rebate.searchPlaceholder': '按直播團隊名稱、賣家ID或會員ID搜尋',
  'pages.live.rebate.search': '搜尋',
  'pages.live.rebate.reset': '重置',
  'pages.live.rebate.teamLead': '團隊負責人',
  'pages.live.rebate.teamLeadId': '團隊負責人ID',
  'pages.live.rebate.teamLeadIdRequired': '請輸入團隊負責人ID',
  'pages.live.rebate.teamInternalSelfPercent': '團隊內部自身%',
  'pages.live.rebate.teamInternalSelfPercentRequired': '請輸入團隊內部自身百分比',
  'pages.live.rebate.teamInternalUplinePercent': '團隊內部上級%',
  'pages.live.rebate.teamRebate': '團隊返利',
  'pages.live.rebate.memberSettings': '成員設定',
  'pages.live.rebate.memberSettingsTitle': '按賣家返利設定',
  'pages.live.rebate.memberSettingsHint': '設定單一賣家的返利比例。儲存後該賣家的結算將使用此值而非團隊設定；「未設定」的賣家繼續使用團隊設定。',
  'pages.live.rebate.memberSource': '設定來源',
  'pages.live.rebate.memberSourceTeamCopy': '複製自團隊',
  'pages.live.rebate.memberSourceAdmin': '單獨設定',
  'pages.live.rebate.memberSourceNone': '未設定（使用團隊設定）',
  'pages.live.rebate.memberSourceTeamConfig': '團隊設定',
  'pages.live.rebate.memberSelfPercent': '自留 %',
  'pages.live.rebate.memberSave': '儲存',
  'pages.live.rebate.memberSaveSuccess': '賣家返利設定已儲存',
  'pages.live.rebate.memberSaveFailed': '儲存賣家返利設定失敗',
  'pages.live.rebate.memberLoadFailed': '載入團隊成員失敗',
  'pages.live.rebate.marginSumError': '賣家+公司+團隊 % 總和必須為 100',
  'pages.live.rebate.teamLeadTag': '團長',
  'pages.live.rebate.teamInternalUplinePercentRequired': '請輸入團隊內部上級百分比',
  'pages.live.rebate.configuredAt': '配置時間',
  'pages.live.rebate.configuredAtRequired': '請選擇配置時間',
  'pages.live.sellers.userId': '用戶 ID',
  'pages.live.sellers.sellerId': '賣家 ID',
  'pages.live.sellers.name': '姓名',
  'pages.live.sellers.recommender': '推薦人',
  'pages.live.sellers.team': '團隊人數',
  'pages.live.sellers.follower': '關注者',
  'pages.live.sellers.salesAmount': '銷售金額',
  'pages.live.sellers.salesCount': '銷售數量',
  'pages.live.sellers.rebate': '返利累計',
  'pages.live.sellers.refundAmount': '退款金額',
  'pages.live.sellers.rebateDeduction': '返利扣除',
  'pages.live.sellers.liveStatus': '直播狀態',
  'pages.live.sellers.liveStatus.live': '直播中',
  'pages.live.sellers.liveStatus.idle': '待機',
  'pages.live.sellers.homepage': '主頁',
  'pages.live.sellers.homepageLink': '鏈接',
  'pages.live.sellers.sellerMailbox': '賣家信箱號',
  'pages.live.sellers.sellerNickname': '賣家暱稱',
  'pages.live.sellers.rebateAccrued': '返利累計',
  'pages.live.sellers.rebateDeducted': '返利扣減',
  'pages.live.sellers.deposit': '保證金',
  'pages.live.sellers.livePage': '直播頁',
  'pages.live.sellers.actions': '操作',
  'pages.live.rebate.levelDetailTitle': '直播團隊列表',
  'pages.live.rebate.levelDetail.column.teamName': '團隊名稱',
  'pages.live.rebate.levelDetail.column.depth': '層級',
  'pages.live.rebate.levelDetail.column.userUniqueId': '賣家ID',
  'pages.live.rebate.levelDetail.column.userId': '用戶ID',
  'pages.live.rebate.levelDetail.column.userName': '用戶名稱',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': '下級數量',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': '銷售金額 (KRW)',
  'pages.live.rebate.levelDetail.column.marginAmountKrw': '毛利金額 (KRW)',
  'pages.live.rebate.levelDetail.column.salesQuantity': '銷售數量',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': '退款金額 (KRW)',
  'pages.live.rebate.levelDetail.column.refundQuantity': '退款數量',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': '團隊返利累計 (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': '團隊返利扣除 (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': '退款後團隊返利 (KRW)',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': '公司累計 (KRW)',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': '公司扣除 (KRW)',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': '退款後公司 (KRW)',
  'pages.live.rebate.levelDetail.column.action': '操作',
  'pages.live.rebate.levelDetail.searchLabel': '搜尋：',
  'pages.live.rebate.levelDetail.searchPlaceholder': '按賣家ID、用戶ID或用戶名稱搜尋...',
  'pages.live.rebate.levelDetail.searchButton': '搜尋',
  'pages.live.rebate.levelDetail.resetButton': '重置',
  'pages.live.rebate.levelDetail.reloadButton': '重新載入',
  'pages.live.rebate.levelDetail.detailButton': '詳情',
  'pages.live.rebate.levelDetail.loadError': '載入直播返利詳情資料失敗',
  'pages.live.rebate.levelDetail.level1': '層級 1',
  'pages.live.rebate.levelDetail.level2': '層級 2',
  'pages.live.rebate.levelDetail.level3': '層級 3',
  'pages.live.rebate.levelDetail.level4': '層級 4',
};
